import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [messageError, setMessageError] = useState("");

  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // Reset error messages
    setEmailError("");
    setSubjectError("");
    setMessageError("");

    // Validate inputs
    const emailInput = form.current.elements.email.value;
    const subjectInput = form.current.elements.subject.value;
    const messageInput = form.current.elements.message.value;

    let isValid = true;

    if (!emailInput || !isValidEmail(emailInput)) {
      setEmailError("Please enter a valid email address.");
      isValid = false;
    }

    if (!subjectInput) {
      setSubjectError("Please enter a subject.");
      isValid = false;
    }

    if (!messageInput) {
      setMessageError("Please enter a message.");
      isValid = false;
    }

    if (isValid) {
      emailjs
        .sendForm(serviceId, templateId, form.current, {
          publicKey: publicKey,
        })
        .then(
          (response) => {
            console.log("SUCCESS!");
            setSuccessMessage("Message sent successfully!");
            setErrorMessage("");
            form.current.reset(); // Reset the form fields
          },
          (error) => {
            console.error("FAILED...", error);
            setErrorMessage("Failed to send message. Please try again later.");
            setSuccessMessage("");
          }
        );
    }
  };

  const isValidEmail = (email) => {
    // Basic email validation regex
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    const errorTimeout = setTimeout(() => {
      setErrorMessage("");
    }, 10000);

    const successTimeout = setTimeout(() => {
      setSuccessMessage("");
    }, 10000);

    return () => {
      clearTimeout(errorTimeout);
      clearTimeout(successTimeout);
    };
  }, [errorMessage, successMessage]);

  return (
    <div className=" bg-gray-200 dark:bg-gray-900 h-[calc(87dvh)]">
      <div className="py-8 lg:py-10 px-4 mx-auto max-w-screen-md">
        <h1 className="mb-4 text-2xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
          Contact Me
        </h1>

        <form ref={form} className="space-y-8 noValidate">
          <div>
            <label
              htmlFor="email"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Your email
            </label>
            <input
              type="email"
              name="email"
              id="email"
              className={`shadow-sm bg-gray-50 border ${
                emailError ? "border-red-500" : "border-gray-300"
              } text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light`}
              placeholder="name@google.com"
              required
            />
            {emailError && (
              <p className="text-red-500 text-sm mt-1">{emailError}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="subject"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Subject
            </label>
            <input
              type="text"
              name="subject"
              id="subject"
              className={`block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border ${
                subjectError ? "border-red-500" : "border-gray-300"
              } shadow-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light`}
              placeholder="Subject"
              required
            />
            {subjectError && (
              <p className="text-red-500 text-sm mt-1">{subjectError}</p>
            )}
          </div>
          <div className="sm:col-span-2">
            <label
              htmlFor="message"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
            >
              Your message
            </label>
            <textarea
              name="message"
              id="message"
              rows="6"
              className={`block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border ${
                messageError ? "border-red-500" : "border-gray-300"
              } focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500`}
              placeholder="Leave a comment..."
              required
            ></textarea>
            {messageError && (
              <p className="text-red-500 text-sm mt-1">{messageError}</p>
            )}
          </div>
          <button
            type="submit"
            onClick={sendEmail}
            className=" animate-rotate-y animate-once mt-5 py-3 px-5 text-sm font-bold text-center text-gray-950 rounded-3xl bg-yellow-500 sm:w-fit hover:bg-yellow-600 focus:ring-4 focus:outline-none focus:ring-primary-300"
          >
            Send message
          </button>
        </form>
        {errorMessage && (
          <div className="text-red-600 mt-4 text-2xl font-bold">
            {errorMessage}
          </div>
        )}
        {successMessage && (
          <div className="text-green-600 mt-4 text-2xl font-bold">
            {successMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default Contact;
